// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"d5c57b03","297":"e848971c","306":"07bd45fc","598":"94f80bbe","629":"3a474d12","774":"02a349c1","813":"62e3a75b","939":"eb9d84eb","979":"7f4db606"}[chunkId] + ".chunk.js";
};